import * as React from 'react';
import { useState } from 'react';
import styles from './RecoverPassword.module.scss';
import { RouteComponentProps, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Field, Form } from 'react-final-form';
import SVG from 'react-inlinesvg';
import { Button } from '../../components/Button/Button';
import { Dispatch, bindActionCreators } from 'redux';
import { recoverPasswordRequestAction } from '../../store/me/actions';
import { RootState } from '../../store';
import { BounceLoader } from 'react-spinners';
import { Link } from 'react-router-dom';
import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/icons/tipster-small-logo.svg';
import close from '../../assets/icons/close.svg';

interface DispatchProps {
  recoverPasswordRequest: (values: any) => any;
}
interface StateProps {
  isRecoverPasswordLoading: any;
  isRecoverPasswordErroring: any;
  didRecoverPasswordSucceed: any;
  email: any;
  sent: boolean;
}

type RecoverPasswordProps = StateProps & RouteComponentProps & DispatchProps;
export const RecoverPassword: React.FC<
  RecoverPasswordProps & RouteComponentProps
> = (props) => {
  const { t } = useTranslation();
  const required = (value: string) => (value ? undefined : 'Requerido');
  const validEmail = (value: string) => {
    // eslint-disable-next-line
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
      return undefined;
    }
    return 'El correo electrónico no es valido';
  };
  const [email, setemail] = useState(null);
  const [resend, setresend] = useState(false);
  const composeValidators =
    (...validators: any[]) =>
    (value: any) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined,
      );

  const onSubmit = (value: any) => {
    props.recoverPasswordRequest(value);
    setemail(value.email);
  };

  return resend || props.didRecoverPasswordSucceed ? (
    <div className={styles.container}>
      <form>
        <h2>{tr(t, 'recover-pwd_title')}</h2>
        <p>
          {tr(t, 'recover-pwd_email-sent') +
            ' ' +
            email +
            ', ' +
            tr(t, 'recover-pwd_email-sent2')}
        </p>
        <Link to="/login">
          <Button
            type={'submit'}
            action={() => {}}
            text={tr(t, 'got-it')}
            theme={'primary'}
          />
        </Link>
        <div
          className={styles.green}
          onClick={() => {
            setresend(true);
            props.recoverPasswordRequest(email);
          }}
        >
          <a // eslint-disable-line
          >
            {tr(t, 'resend-email')}
          </a>
        </div>
      </form>
    </div>
  ) : (
    <div className={styles.container}>
      <Link to="/login">
        <SVG src={close} />
      </Link>

      <Form
        onSubmit={onSubmit}
        //@ts-ignore
        render={({ handleSubmit, invalid, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <SVG src={logo} />

              <h2>{tr(t, 'recover-pwd_title')}</h2>
              <p>{tr(t, 'recover-pwd_subtitle')}</p>
              <div className={styles.newPassword}>
                <Field
                  name="email"
                  component="input"
                  validate={composeValidators(required, validEmail)}
                >
                  {({ input, meta }) => (
                    <>
                      <input
                        {...input}
                        type="email"
                        placeholder={tr(t, 'email-address')}
                      />
                      {meta.error && meta.touched && (
                        <span className={styles.error}>{meta.error}</span>
                      )}
                    </>
                  )}
                </Field>
              </div>

              <Button
                type={'submit'}
                disabled={invalid || props.isRecoverPasswordLoading}
                action={() => {}}
                text={tr(t, 'send-email')}
                theme={'primary'}
              />
            </form>
          );
        }}
      />
      {props.isRecoverPasswordLoading && (
        <div className={styles.spinnerContainer}>
          <BounceLoader color={'#27de81'} size={25} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  isRecoverPasswordLoading: state.me.isRecoverPasswordLoading,
  isRecoverPasswordErroring: state.me.isRecoverPasswordErroring,
  didRecoverPasswordSucceed: state.me.didRecoverPasswordSucceed,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  recoverPasswordRequest: bindActionCreators(
    recoverPasswordRequestAction,
    dispatch,
  ),
});
export const RecoverPasswordConnected = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RecoverPassword),
);
